import { propOr } from 'ramda'
import { createSelector } from 'reselect'

export const getActive = createSelector(
  (name, state) => propOr(undefined, name, state),
  state => state
)
